// ==================== INITIALIZE GAME ====================
import '../styles/main.scss';
import { Game } from './game.js';

window.addEventListener('load', () => {
    window.game = new Game();
});
